module.exports = __webpack_public_path__ + "img/img34.96b11546.svg";